import React, { useState, useEffect } from "react";
import {IMPORT_TYPES} from "../../constants/general-constants";
import {functions} from "../../constants/common-functions";

export default function UtilisationGridImportPanel() {
	
	
	var [importType, setImportType] = useState('');
	var [importRuns, setImportRuns] = useState([]);
	var [overwriteImportRun, setOverwriteImportRun] = useState("none");
	const [buildingId, setBuildingId] = useState(-100);
	const [allBuildings, setAllBuildings] = useState([]);

  /* =========================
     State
     ========================= */

  var [buildingCode, setBuildingCode] = useState("");
  var [file, setFile] = useState(null);

  var [floorColumn, setFloorColumn] = useState("A");
  var [floorIsCode, setFloorIsCode] = useState(true);

  var [spaceColumn, setSpaceColumn] = useState("B");

  var [spaceTypeColumn, setSpaceTypeColumn] = useState("C");
  var [spaceTypeIsCode, setSpaceTypeIsCode] = useState(true);

  var [departmentColumn, setDepartmentColumn] = useState("D");
  var [departmentIsCode, setDepartmentIsCode] = useState(true);

  var [capacityColumn, setCapacityColumn] = useState("E");
  var [areaColumn, setAreaColumn] = useState("F");

  var [observationStartCol, setObservationStartCol] = useState("G");
  var [observationEndCol, setObservationEndCol] = useState("Z");

  var [status, setStatus] = useState("");
  var [loading, setLoading] = useState(false);
  
  useEffect(() => {
   		
   	 
   	  functions.getArrayFromAjax(
   	    "/resolutionsoftwareplatform/facilities",
   	    setAllBuildings,
   	    null
   	  );

   	 

   	}, []); // 
  
  useEffect(() => {
  		
  	 
  	  functions.getArrayFromAjax(
  	    "/resolutionsoftwareplatform/getimportruns?type=" + importType,
  	    setImportRuns,
  	    null
  	  );

  	 

  	}, [importType]); // 🔥 NOT infoBoxDisplay

  /* =========================
     Column list (A..BZ)
     ========================= */

  function buildColumnList() {
    var cols = [];
    var i;

    for (i = 0; i < 26; i++) {
      cols.push(String.fromCharCode(65 + i));
    }

    for (i = 0; i < 26; i++) {
      cols.push("A" + String.fromCharCode(65 + i));
    }

    for (i = 0; i < 26; i++) {
      cols.push("B" + String.fromCharCode(65 + i));
    }

    return cols;
  }

  var columns = buildColumnList();

  /* =========================
     Handlers
     ========================= */

  function onChooseFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    } else {
      setFile(null);
    }
  }

  function validate() {
    if (!buildingCode || buildingCode.trim().length === 0) {
      setStatus("Please enter a building code.");
      return false;
    }
    if (!file) {
      setStatus("Please choose an Excel file.");
      return false;
    }
    return true;
  }

  function onSubmit() {
    var formData;

    if (!validate()) return;

    setLoading(true);
    setStatus("Uploading...");

    formData = new FormData();
    formData.append("buildingId", buildingId);
    formData.append("file", file);

    formData.append("floorColumn", floorColumn);
    formData.append("floorIsCode", String(floorIsCode));

    formData.append("spaceColumn", spaceColumn);

    formData.append("spaceTypeColumn", spaceTypeColumn);
    formData.append("spaceTypeIsCode", String(spaceTypeIsCode));

    formData.append("departmentColumn", departmentColumn);
    formData.append("departmentIsCode", String(departmentIsCode));

    formData.append("capacityColumn", capacityColumn);
    formData.append("areaColumn", areaColumn);

    formData.append("observationStartCol", observationStartCol);
    formData.append("observationEndCol", observationEndCol);
	
	formData.append("importType", importType);
	formData.append("overwriteImportRun", overwriteImportRun);

    fetch("/upload/utilisation/grid", {
      method: "POST",
      body: formData
    })
      .then(function (res) {
        return res.text().then(function (t) {
          if (!res.ok) {
            throw new Error(t || ("Upload failed (" + res.status + ")"));
          }
          return t;
        });
      })
      .then(function (text) {
        setStatus(text || "Import completed successfully.");
        setLoading(false);
      })
      .catch(function (err) {
        setStatus(err && err.message ? err.message : "Upload failed.");
        setLoading(false);
      });
  }

  /* =========================
     Render helpers
     ========================= */

  function renderColumnSelect(value, onChange) {
    return (
      <select
        style={styles.select}
        value={value}
        onChange={function (e) { onChange(e.target.value); }}
      >
        {columns.map(function (c) {
          return <option key={c} value={c}>{c}</option>;
        })}
      </select>
    );
  }

  function renderMappingRow(label, columnValue, setColumn, showCodeToggle, isCode, setIsCode) {
    return (
      <div style={styles.mappingRow}>
        <div style={styles.mappingLabel}>{label}</div>

        {renderColumnSelect(columnValue, setColumn)}

        {showCodeToggle && (
          <div style={styles.mappingRadios}>
            <label>
              <input
                type="radio"
                checked={isCode === true}
                onChange={function () { setIsCode(true); }}
              />
              Code
            </label>
            <label>
              <input
                type="radio"
                checked={isCode === false}
                onChange={function () { setIsCode(false); }}
              />
              Name
            </label>
          </div>
        )}
      </div>
    );
  }

  /* =========================
     Styles
     ========================= */

  var styles = {

    panel: {
      padding: "14px",
      borderRadius: "8px",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
      width: "820px"
    },

    row: {
      display: "flex",
      gap: "12px",
      alignItems: "flex-end",
      marginBottom: "12px"
    },

    field: {
      display: "flex",
      flexDirection: "column",
      gap: "6px"
    },

    label: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#333"
    },

    input: {
      height: "34px",
      minWidth: "180px",
      padding: "6px 8px",
      borderRadius: "6px",
      border: "1px solid #ccc",
	  width:'200px'
    },

    select: {
      height: "34px",
      width: "110px",
      padding: "6px 8px",
      borderRadius: "6px",
      border: "1px solid #ccc",
	  width:'200px'
    },

    mappingRow: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
      marginBottom: "8px"
    },

    mappingLabel: {
      width: "120px",
      fontSize: "13px",
      fontWeight: "600",
      color: "#333"
    },

    mappingRadios: {
      display: "flex",
      gap: "12px",
      alignItems: "center"
    },

    button: {
      height: "36px",
      padding: "0 16px",
      borderRadius: "8px",
      border: "none",
      backgroundColor: loading ? "#999" : "#1e73ff",
      color: "#fff",
      cursor: loading ? "default" : "pointer",
      fontWeight: "700"
    },

    status: {
      marginTop: "12px",
      fontSize: "13px",
      whiteSpace: "pre-line",
      color: "#111"
    },

    hint: {
      fontSize: "12px",
      color: "#666"
    }
  };
  
  
  function handleChangeImportType(val) {
    setImportType(val);
    setOverwriteImportRun("none"); // reset safely
  }
  
  function handleChangeBuilding(val) {
      setBuildingId(val);
    }

  function handleChangeImportOverwrite(val) {
    setOverwriteImportRun(val);
  }
  

  /* =========================
     Render
     ========================= */

  return (
    <div style={styles.panel}>

      <div style={styles.row}>
       

        <div style={styles.field}>
          <div style={styles.label}>Excel File (.xlsx)</div>
          <input type="file" accept=".xlsx" onChange={onChooseFile} />
          <div style={styles.hint}>Upload the grid spreadsheet</div>
        </div>
      </div>
	  
	  <div style={styles.mappingRow}>
	  	     <div style={styles.mappingLabel}>Import Type</div>
	  		 <div>
			 <select
			   style={styles.select}
			   value={importType}
			   onChange={function (e) { handleChangeImportType(e.target.value); }}
			 >
	  		      {IMPORT_TYPES.map((item, index) =>
					<option key={item.id} value={item.value}>
										     {item.label}
										   </option>
				  )}
	  		      </select>
	  		</div>
	  	 </div>
		 <div style={styles.mappingRow}>
		 	 <div style={styles.mappingLabel}>Select Building</div>
	 	  	<div>
	 			 <select
	 			   style={styles.select}
	 			   value={buildingId}
	 			   onChange={function (e) { handleChangeBuilding(e.target.value); }}
	 			 >
	 	  		       {allBuildings.map((item, index) =>
						<option key={item.id} value={item.id}>
					     {item.name}
					   </option>
						)}
	 	  		      </select>
 	  		</div>
 	  	 </div>
	  <div style={styles.mappingRow}>
	     <div style={styles.mappingLabel}>Overwrite Import</div>
		 <div>
			 <select
		        style={styles.select}
		        onChange={function (e) { handleChangeImportOverwrite(e.target.value); }}
		      >
		       <option value="none">None</option>
			   {importRuns.map((item, index) =>
				<option key={item.id} value={item.id}>
				     {item.title}
				   </option>
				)}
		      </select>
		</div>
	 </div>
	
      <h4>Column Mapping</h4>

      {renderMappingRow("Floor", floorColumn, setFloorColumn, true, floorIsCode, setFloorIsCode)}
      {renderMappingRow("Space Code", spaceColumn, setSpaceColumn, false)}
      {renderMappingRow("Space Type", spaceTypeColumn, setSpaceTypeColumn, true, spaceTypeIsCode, setSpaceTypeIsCode)}
      {renderMappingRow("Department", departmentColumn, setDepartmentColumn, true, departmentIsCode, setDepartmentIsCode)}
      {renderMappingRow("Capacity", capacityColumn, setCapacityColumn, false)}
      {renderMappingRow("Area", areaColumn, setAreaColumn, false)}

      <h4 style={{ marginTop: "14px" }}>Observation Columns</h4>

      <div style={styles.mappingRow}>
        <div style={styles.mappingLabel}>From</div>
        {renderColumnSelect(observationStartCol, setObservationStartCol)}

        <div style={{ width: "40px", textAlign: "center" }}>to</div>

        {renderColumnSelect(observationEndCol, setObservationEndCol)}
      </div>

      <div style={{ marginTop: "16px" }}>
        <button
          style={styles.button}
          disabled={loading}
          onClick={onSubmit}
        >
          {loading ? "Uploading..." : "Import Utilisation Grid"}
        </button>
      </div>

      {status && <div style={styles.status}>{status}</div>}

    </div>
  );
}
